// extracted by mini-css-extract-plugin
module.exports = {"loadMore":"Galleries_loadMore__HxjMn"};